import React, { useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Row,
} from "reactstrap"
import { CurrentTapType, PaymentStatus } from "./ordersType"
import { OrderStatus } from "./Components/OrderStatus"
import "./style.scss"
import OrderItemCard from "./OrderComponents/OrderItemCard"
import CustomerInfo from "./OrderComponents/CustomerInfo"
import PaymentInfo from "./OrderComponents/PaymentInfo"
import DeliveryMan from "./OrderComponents/DeliveryMan"
import OrderState from "./OrderComponents/OrderState"
import { EditOrderModal } from "pages/admin/Orders/Modals"
import { useTranslation } from "react-i18next"

const order = {
  id: "ID-145871",
  createdDate: "25 May, 2023",
  orderStatus: CurrentTapType.pending,
  orderValue: "QAR 50",
  paymentDetails: {
    paymentStatus: PaymentStatus.pendingPayment,
    paymentMethod: "Cash On Delivery",
    totalPrice: "QAR 300",
    deliveryFee: "QAR 20",
    discount: "QAR 30",
    totalAmount: "QAR 290",
  },
  address: "123 Main St, Anytown, USA",
  items: 3,
  createdBy: {
    name: "Amr Kamal",
    phone: "123456789",
    image: "https://placehold.co/40x40",
  },
  itemsList: [
    {
      name: "Item 1",
      price: "QAR 10",
      quantity: 2,
      category: "Category 1",
      brand: "Brand 1",
      rate: 5.0,
      image: "https://placehold.co/80x80",
    },
    {
      name: "Item 2",
      price: "QAR 20",
      quantity: 1,
      category: "Category 2",
      brand: "Brand 2",
      rate: 5.0,
      image: "https://placehold.co/80x80",
    },
  ],
  deliveryMan: {
    name: "John Doe",
    phone: "123456789",
    image: "https://placehold.co/40x40",
  },
  orderState: [
    {
      date: "25 May, 2023",
      status: "Order delivered",
    },
    {
      date: "25 May, 2023",
      status: "Order shipping",
    },
    {
      date: "25 May, 2023",
      status: "Order assigned to delivery man",
    },
    {
      date: "24 May, 2023",
      status: "you accept order",
    },
    {
      date: "23 May, 2023",
      status: "Order created",
    },
  ],
  coupon: {
    total: 20,
    used: 5,
  },
}
const Order = () => {
  const [copied, setCopied] = useState(false)
  const [showEditOrderModal, setShowEditOrderModal] = useState(false)
  const { t } = useTranslation()

  const [openAccordion, setOpenAccordion] = useState({
    orderId: "0",
    basicInfo: "0",
    customerInfo: "0",
    paymentInfo: "0",
    deliverInfo: "0",
    orderState: "0",
  })

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500) // يختفي بعد 1.5 ثانية
    })
  }

  const percentage = Math.min(
    ((order.coupon.total - order.coupon.used) / order.coupon.total) * 100,
    100
  ) // 0 - 100%
  return (
    <div className="page-content d-flex flex-column">
      <div className="container-fluid p-0">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <Breadcrumbs
            title={t("dashboard_dashboard")}
            breadcrumbItem={t("orders_orderDetrails")}
          />
          <button
            onClick={() => setShowEditOrderModal(true)}
            className="btn bg-gradiant-blue border-0 text-white"
          >
            <i className="bx bx-pencil"></i> {t("orders_editOrder")}
          </button>
        </div>
        {/* Order Data */}
        <Card className="text-center border border-1 shadow-sm bg-semi-white">
          <CardBody className="p-3 border-1 shadow">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex flex-column">
                <p className=" mb-0 text-muted">
                  <span className="font-size-16 text-semi-dark fw-semibold mx-2">
                    {t("orders_orderId")}
                  </span>
                  {order.id}
                  <button
                    className="relative cursor-pointer d-inline-block border-0 bg-transparent"
                    onClick={() => {
                      copyToClipboard(order.id)
                    }}
                  >
                    <i className="bx bx-copy px-2 text-primary bx-sm cursor-pointer"></i>
                    {copied && (
                      <span
                        className="position-absolute  translate-middle-x mt-1 text-success small"
                        style={{ top: "14px", marginLeft: "20px" }}
                      >
                        {t("common_copied")}
                      </span>
                    )}
                  </button>
                </p>
                <div className="text-muted fw-bold small mt-2 align-self-start">
                  <span className="mx-2 text-semi-dark text-size-14">
                    {t("common_createdAt")}
                  </span>
                  <span className="fw-normal">{order.createdDate}</span>
                </div>
              </div>
              <OrderStatus orderStatus={order.orderStatus} />
            </div>
          </CardBody>
        </Card>
        {/* Basic Info */}
        <Accordion
          open={openAccordion.basicInfo}
          className="border-0 bg-semi-white order-item mb-4 "
        >
          <AccordionItem>
            <AccordionHeader
              className="font-size-16 text-semi-dark fw-semibold mx-2"
              targetId="0"
              onClick={() =>
                setOpenAccordion({
                  ...openAccordion,
                  basicInfo: openAccordion.basicInfo === "0" ? "1" : "0",
                })
              }
            >
              {t("common_basicInfo")}
            </AccordionHeader>
            <AccordionBody accordionId="0">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <p className="mb-0 text-muted">
                  <span className="font-size-16 text-semi-dark fw-semibold mx-2">
                    {t("orders_totalPrice")}
                  </span>
                  {order.orderValue}
                </p>
                <p className="mb-0 text-muted">
                  <span className="font-size-16 text-semi-dark fw-semibold mx-2">
                    {t("orders_totalItems")}
                  </span>
                  {order.items}
                </p>
              </div>
              <Row>
                {order.itemsList.map((item, index) => (
                  <OrderItemCard key={index} item={item} />
                ))}
              </Row>

              {/* coupon */}
              {Object.keys(order.coupon).length > 0 && (
                <div className="">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <p className="mb-0 text-muted">
                      <span className="font-size-16 text-semi-dark fw-semibold mx-2">
                        {t("orders_couponBalance")}
                      </span>
                    </p>
                    <p className="mb-0 text-muted">
                      <span className="badge font-size-14 mx-2 bg-primary-30 text-primary">
                        {order.coupon.total - order.coupon.used}{" "}
                        {t("common_left")}
                      </span>
                    </p>
                  </div>
                  <div
                    className="progress bg-primary-20 rounded-full my-3"
                    style={{ height: "12px" }}
                  >
                    <div
                      className="progress-bar bg-primary"
                      role="progressbar"
                      style={{ width: `${percentage}%` }}
                    >
                      {order.coupon.used} / {order.coupon.total}
                    </div>
                  </div>
                </div>
              )}
              <div className="d-flex w-full justify-content-between">
                <span className="text-primary font-size-12">
                  {order.coupon.total} {t("orders_total")}
                </span>
                <span className="text-primary font-size-12">
                  {order.coupon.used} {t("orders_used")}
                </span>
                <span className="text-primary font-size-12">
                  {order.coupon.total - order.coupon.used}{" "}
                  {t("orders_remaining")}
                </span>
              </div>
            </AccordionBody>
          </AccordionItem>
        </Accordion>

        {/* Customer Info */}
        <CustomerInfo
          openAccordion={openAccordion}
          setOpenAccordion={setOpenAccordion}
          order={order}
        />

        {/* Payment Info */}
        <PaymentInfo
          openAccordion={openAccordion}
          setOpenAccordion={setOpenAccordion}
          order={order}
        />

        {/* Delivery Info */}
        <DeliveryMan
          openAccordion={openAccordion}
          setOpenAccordion={setOpenAccordion}
          order={order}
        />

        {/* Order State */}
        <OrderState
          openAccordion={openAccordion}
          setOpenAccordion={setOpenAccordion}
          order={order}
        />

        {/* Modals */}
        <EditOrderModal
          isOpen={showEditOrderModal}
          order={null}
          toggle={() => setShowEditOrderModal(false)}
        />
      </div>
    </div>
  )
}

export default Order
